
function PartnerFormSubmissionSuccessful() {
    return (
        <>
            <h1 style={{margin: '20px'}}>Thank you for submtting the form. We'll be in touch!</h1> 
        </>
    )
}

export default PartnerFormSubmissionSuccessful;